import C from './constants';
import P from './paths';
import Pages from './pages';
import fetch from 'isomorphic-fetch';
import axios from 'axios';
import FormData from 'form-data';
import ReactOnRails from 'react-on-rails';
import { buildProfileForm, updateForm } from '../../shared/profileElementHelpers';
import { blankOrValue } from '../../shared/utilities';
import {
  setNextPage,
  setPage,
  setPages,
  setPreviousPage,
  setProfileElements,
  setAddress
} from '../../shared/actions';

const handleErrors = response => {
  const ok = response.ok || response.status === 200

  if (!ok) {
    var error = new Error(response.statusText || response.status);
    error.response = response;
    throw error;
  }
  return response;
};

const profileSectionToSubmit = (page) => {
  if ([Pages.GUARDIAN_EMERGENCY_PAGE].indexOf(page) > -1) {
    return ['contact'];
  } else if ([Pages.LANGUAGE_NATIONALITY_PAGE].indexOf(page) > -1) {
    return ['personal'];
  } else if ([Pages.PERSONALITY_PROFILE_PAGE].indexOf(page) > -1) {
    return ['personal', 'placement'];
  } else if ([Pages.PETS_CHILDREN_PAGE, Pages.MEDICAL_PAGE].indexOf(page) > -1) {
    return ['preferences'];
  } else if ([Pages.PLACEMENT_PAGE].indexOf(page) > -1) {
    return ['placement'];
  } else if ([Pages.EDUCATION_PAGE].indexOf(page) > -1) {
    return ['education'];
  } else if ([Pages.PRODUCT_PAGE].indexOf(page) > -1){
    return ['preferences', 'service', 'placement']
  } else {
    return null;
  }
}

export const backToAddress = () => dispatch => {
  dispatch(setAddress(null))
  dispatch(setPage(Pages.ADDRESS_PAGE))
}

export const registerUser = payload => (dispatch, getState) => {
  const formUrl = '/guests.js';
  let form = new FormData();
  let { affiliate, territory, referral, pages, guest_kind, guest_kind_unknown_place } = getState()
  let highSchoolGuestType = territory.guest_types.find(t => t.code == 'high-school-student')
  let highSchoolStudent = highSchoolGuestType && payload.user.guestType == highSchoolGuestType.id

  form.append('authenticity_token', ReactOnRails.authenticityToken());
  form.append('affiliate', blankOrValue(payload.affiliate) || '');
  form.append('firebase_id', blankOrValue(payload.firebase_id));
  form.append('user[email]', payload.user.email);
  form.append('user[given_names]', payload.user.givenNames);
  form.append('user[family_name]', payload.user.familyName);
  form.append('user[gender]', blankOrValue(payload.user.gender));
  form.append('user[dob]', payload.user.dob);
  form.append('user[password]', payload.user.password || '');
  form.append('user[guest_attributes][guest_type_id]', payload.user.guestType);
  form.append('user[guest_attributes][signup_method]', 'wizard_v1');
  form.append('user[guest_attributes][territory_id]', territory.id);
  form.append('user[guest_attributes][referred_from]', payload.user.referredFrom);
  form.append('user[guest_attributes][referral_uid]', blankOrValue(referral.referral_uid));
  form.append('user[guest_attributes][kind]', guest_kind || 'standard');
  form.append('guest[profile_elements][placement][intended_start]', payload.user.intendedStart);
  form.append('guest[profile_elements][placement][intended_vacate]', payload.user.intendedVacate || '');
  form.append('guest[profile_elements][placement][airport_pickup_required]', highSchoolStudent && territory.code == 'SRSC' ? 'Yes' : '');
  form.append('guest[profile_elements][personal][nationality]', payload.user.nationality);
  form.append('guest[profile_elements][contact][contact_details][wechat_id]', blankOrValue(payload.user.weChatId));
  form.append('guest[profile_elements][contact][contact_details][phone]', blankOrValue(payload.user.phone));

  if (payload.city) {
    form.append('city[id]', blankOrValue(payload.city.id));
    form.append('city[google]', blankOrValue(payload.city.google));
    if (payload.city.coordinates){
      form.append('city[coordinates]', blankOrValue([payload.city.coordinates.lat, payload.city.coordinates.lng]));
    }
    form.append('city[name]', blankOrValue(payload.city.name));
    form.append('city[state]', blankOrValue(payload.city.state));
    form.append('city[postcode]', blankOrValue(payload.city.postcode));
  } else if (payload.place) {
    form.append('place[id]', blankOrValue(payload.place.id));
    form.append('place[google]', blankOrValue(payload.place.google));
  }

  const submitForm = async() => {
    return await fetch(formUrl, {
      method: 'post',
      credentials: 'same-origin',
      headers: {'X-Requested-With': 'XMLHttpRequest'},
      body: form
    })
  }
  submitForm()
  .then(handleErrors)
  .then(response => response.json())
  .then(data => {
    dispatch(setUser(data.user))
    dispatch(setProfileElements(data.profile_elements))
    dispatch(setRegistered(true))

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'hms_signup_success',
      userType: 'guest'
    });

    if (data.user.guest.type.code == 'college-student' && territory.code == 'SRSC'){
      dispatch(setPages(pages.filter(p => p != 'education')))
    }
    if (data.user.guest.kind != 'standard'){
      const pagesToSkip = ['product']

      if (guest_kind_unknown_place) {
        pagesToSkip.push('personality_profile')
        pagesToSkip.push('education')
        pagesToSkip.push('language_nationality')
      }

      dispatch(setPages(pages.filter(p => !pagesToSkip.includes(p))))
    }
  })
};

export const authUser = payload => dispatch => {
  const token = payload.token
  const authenticatedUser = async () => {
    return (
      await fetch('/guests/create_authenticated_user', {
        method: 'post',
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        },
        body: JSON.stringify({ token })
      })
    )
  }

  authenticatedUser()
  .then(handleErrors)
  .then(response => response.json())
  .then(data => {
    const user = {
      authId: data.authenticated_user_id,
      email: payload.email,
      password: payload.password
    }

    if (data.success) {
      dispatch(setUser(user))
    } else {
      throw new Error(data.message)
      console.log(data.message)
    }
  })
}

export const updateVaccinationInfo = payload => dispatch => {
  const data = new FormData();
  data.append('authenticity_token', ReactOnRails.authenticityToken())
  data.append('guest[state]', payload.guest.state)
  data.append('guest[dose_one_on]', payload.guest.doseOneOn)
  data.append('guest[dose_two_on]', payload.guest.doseTwoOn)

  const vaccinationInfoSubmit = async () => {
    return await fetch('/guests/update_vaccination_info', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {'X-Requested-With': 'XMLHttpRequest'},
      body: data
    })
  }

  vaccinationInfoSubmit()
  .then(handleErrors)
  .then(response => response.json())
  .then(data => {
    dispatch(setVaccinationInfo(data.vaccination))
  })
  .then(() => {
    if (payload.certificate) {
      dispatch(certificateFormSubmit(payload.certificate))
    }
  })
}

export const certificateFormSubmit = payload => dispatch => {
  let form = new FormData();

  form.append('authenticity_token', ReactOnRails.authenticityToken());
  form.append('guest_id', payload.guest_id);
  form.append('attachment[name]', payload.attachment.name);
  form.append('attachment[kind]', payload.attachment.kind);
  form.append('attachment[file]', payload.attachment.file);

  dispatch(setUploadStatus('Uploading'))

  const submit = async () => (
    await axios({
      url: '/guests/upload_certificate.js',
      method: 'POST',
      credentials: 'same-origin',
      headers: {'X-Requested-With': 'XMLHttpRequest'},
      onUploadProgress: progressEvent => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)

        dispatch(setUploadProgress(percentCompleted))
        if (percentCompleted > 99) dispatch(setUploadStatus('Processing'))
      },
      data: form
    })
  )

  submit()
  .then(handleErrors)
  .then(response => response.data)
  .then(data => {
    dispatch(setVaccinationInfo(data.vaccination))
  })
  .then(() => {
    dispatch(setUploadStatus('Success'))
  })
};

// Submit profile
export const guestProfileSubmit = (payload, page, changePage = true) => (dispatch, getState) => new Promise((resolve) => {
  const formUrl = '/profile_element_entries.json'
  const profileElements = getState().profileElements
  const authenticityToken = ReactOnRails.authenticityToken()
  const profileForm = buildProfileForm()
  const profileElementsForPage = profileSectionToSubmit(page).reduce((obj, item) => {
    obj[item] = profileForm[item]
    return obj
  }, {})
  const guestId = getState().user.guest.id

  let profileElementEntry = updateForm(profileElementsForPage, payload);
  let form = {
    authenticity_token: authenticityToken,
    admin: false,
    doc_id: guestId,
    doc_type: 'Lobby::Guest',
    profile_element_entry: profileElementEntry
  }

  const profileSubmit = async () => {
    return await fetch(formUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(form)
    })
  }
  profileSubmit()
  .then(handleErrors)
  .then(response => response.json())
  .then(data => {
    dispatch(setProfileElements(data))
  })
  .then(() => {
    if (changePage){ dispatch(setNextPage(true)) }
  })
  .then(() => resolve())
})

// Product
export const productSubmit = payload => (dispatch, getState) => {
  const formUrl = `/guests/${payload.user.guest.id}/update_product.json`;
  let form = new FormData();
  form.append('authenticity_token', ReactOnRails.authenticityToken());
  form.append('wizard', true);
  form.append('dietary_requirements', payload.dietary_requirements);
  const updateProduct = async() => {
    return await fetch(formUrl, {
      method: 'post',
      credentials: 'same-origin',
      headers: {'X-Requested-With': 'XMLHttpRequest'},
      body: form
    })
  };

  dispatch(guestProfileSubmit(payload.profile_elements, Pages.PRODUCT_PAGE, false))
  .then(() => {
    updateProduct()
    .then(handleErrors)
    .then(response => response.json())
    .then(response => {
      dispatch(setProduct(response))
    })
    .then(() => {
      dispatch(setNextPage(true))
    })
  })
}

export const departureSubmit = payload => dispatch => {
  const existing = payload.departureId.val || payload.pickupId.val
  const formUrl = existing ? `/guests/update_arrival.js` : `/guests/new_arrival.js`;
  const formMethod = existing ? 'PATCH' : 'post';
  const updateDeparture = async() => {
    return await fetch(formUrl, {
      method: formMethod,
      credentials: 'same-origin',
      headers: {'X-Requested-With': 'XMLHttpRequest'},
      body: form
    })
  };
  let form = new FormData();
  form.append('authenticity_token', ReactOnRails.authenticityToken());
  form.append('place_search_arrival', blankOrValue(payload.departurePlaceName.val))
  form.append('arrival[kind]', 'departure')
  form.append('arrival[place_id]', blankOrValue(payload.departurePlaceId.val))
  form.append('arrival[date]', blankOrValue(payload.departureDate.val))
  form.append('arrival[time(5i)]', blankOrValue(payload.departureTime.val))
  form.append('arrival[vessel_no]', blankOrValue(payload.departureVesselNo.val))
  form.append('arrival[notes]', blankOrValue(payload.departureNotes.val))
  form.append('pickup[kind]', 'departure')
  form.append('pickup[date]', blankOrValue(payload.pickupDate.val))
  form.append('pickup[arrival_time(5i)]', blankOrValue(payload.pickupTime.val))
  form.append('pickup[transport_type]', blankOrValue(payload.pickupTransportType.val))
  form.append('pickup[contact_type]', blankOrValue(payload.pickupContactType.val))
  form.append('pickup[contact_name]', blankOrValue(payload.pickupContactName.val))
  form.append('pickup[contact_phone]', blankOrValue(payload.pickupContactPhone.val))
  form.append('pickup[time(5i)]', blankOrValue(payload.pickupTime.val))
  form.append('pickup[notes]', blankOrValue(payload.pickupNotes.val))
  form.append('attachment[name]', 'Departure Flight Booking');
  form.append('attachment[kind]', 'departure_flight_booking');
  form.append('attachment[file]', payload.departureFlightBooking.val);

  updateDeparture()
  .then(handleErrors)
  .then(response => response.json())
  .then(response => {
    dispatch(setDeparture(response.arrival));
    dispatch(setDeparturePickup(response.pickup));
    dispatch(setNextPage(true));
  })
};

export const arrivalSubmit = payload => dispatch => {
  const existing = payload.arrivalId.val || (payload.onshore == 'Yes' && payload.pickupId.val)
  const formUrl = existing ? `/guests/update_arrival.js` : `/guests/new_arrival.js`;
  const formMethod = existing ? 'PATCH' : 'post';
  const updateArrival = async() => {
    return await fetch(formUrl, {
      method: formMethod,
      credentials: 'same-origin',
      headers: {'X-Requested-With': 'XMLHttpRequest'},
      body: form
    })
  };
  let form = new FormData();
  form.append('authenticity_token', ReactOnRails.authenticityToken());
  form.append('place_search_arrival', blankOrValue(payload.arrivalPlaceName.val))
  form.append('arrival[place_id]', blankOrValue(payload.arrivalPlaceId.val))
  form.append('arrival[date]', blankOrValue(payload.arrivalDate.val))
  form.append('arrival[time(5i)]', blankOrValue(payload.arrivalTime.val))
  form.append('arrival[vessel_no]', blankOrValue(payload.arrivalVesselNo.val))
  form.append('arrival[notes]', blankOrValue(payload.arrivalNotes.val))
  form.append('pickup[date]', blankOrValue(payload.pickupDate.val))
  form.append('pickup[arrival_time(5i)]', blankOrValue(payload.pickupTime.val))
  form.append('pickup[transport_type]', blankOrValue(payload.pickupTransportType.val))
  form.append('pickup[contact_type]', blankOrValue(payload.pickupContactType.val))
  form.append('pickup[contact_name]', blankOrValue(payload.pickupContactName.val))
  form.append('pickup[contact_phone]', blankOrValue(payload.pickupContactPhone.val))
  form.append('pickup[place_id]', blankOrValue(payload.pickupPlaceId.val))
  form.append('pickup[place_name]', blankOrValue(payload.pickupPlaceName.val))
  form.append('pickup[time(5i)]', blankOrValue(payload.pickupPickupTime.val))
  form.append('pickup[notes]', blankOrValue(payload.pickupNotes.val))
  form.append('onshore', blankOrValue(payload.onshore == 'Yes'))
  form.append('attachment[name]', 'Arrival Flight Booking');
  form.append('attachment[kind]', 'arrival_flight_booking');
  form.append('attachment[file]', payload.arrivalFlightBooking.val);

  updateArrival()
  .then(handleErrors)
  .then(response => response.json())
  .then(response => {
    dispatch(setArrival(response.arrival));
    dispatch(setPickup(response.pickup));
    dispatch(setOnshore(response.onshore));
    dispatch(setNextPage(true));
  })
};

export const completeWizard = payload => dispatch => new Promise((resolve) => {
  const url = '/guests/complete_wizard';
  let form = new FormData();
  form.append('authenticity_token', ReactOnRails.authenticityToken());
  fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {'X-Requested-With': 'XMLHttpRequest'},
      body: form
  })
  .then(response => response.json())
  .then(response => {
    dispatch(
      setCompleted(true)
    );
  })
  .then(() => resolve())
})

export const addPhoto = payload => ( dispatch, getState ) => new Promise((resolve) => {
  const formUrl = `/guest_photos${payload.id ? `/${payload.id}` : ''}.json`
  let form = new FormData();
  form.append('authenticity_token', ReactOnRails.authenticityToken())
  form.append('photo[image]', payload.file)
  form.append('photo[name]', payload.name)
  form.append('photo[description]', payload.description)
  form.append('photo[kind]', payload.kind)

  const submitForm = async() => {
    return await fetch(formUrl, {
      method: payload.id ? 'PATCH' : 'POST',
      credentials: 'same-origin',
      headers: {'X-Requested-With': 'XMLHttpRequest'},
      body: form
    })
  }
  submitForm()
  .then(handleErrors)
  .then(response => response.json())
  .then(data => {
    let user = getState().user
    dispatch(setUser({
      ...user,
      guest: {
        ...user.guest,
        photos: data
      }
    }))
  })
  .then(() => resolve())
})

export const destroyPhoto = photoId => ( dispatch, getState ) => {
  let user = getState().user
  let reducedPhotos = user.guest.photos.filter(p => p.id != photoId)
  dispatch(setUser({
    ...user,
    guest: {
      ...user.guest,
      photos: reducedPhotos
    }
  }))
  const formUrl = `/guest_photos/${photoId}.json`;
  let form = new FormData();
  form.append('authenticity_token', ReactOnRails.authenticityToken())
  fetch(formUrl, {
    method: 'DELETE',
    credentials: 'same-origin',
    headers: {'X-Requested-With': 'XMLHttpRequest'},
    body: form
  })
}

// Update page
export const updateSignupPage = page => {
  if (page && page != '' && page != 'register'){
    const url = `/guests/signup/update_page`;
    let form = new FormData();
    form.append('page', page);
    fetch(url, {
      method: 'PATCH',
      credentials: 'same-origin',
      headers: {'X-Requested-With': 'XMLHttpRequest'},
      body: form
    });
  }
};

export const skipSubmit = payload => dispatch => {
  dispatch(
    setNextPage(true)
  );
};

export const goBack = payload => dispatch => {
  dispatch(
    setPreviousPage(true)
  );
};
// new constants

// Others
export const setAffiliate = (affiliate) =>
  ({
    type: C.SET_AFFILIATE,
    payload: affiliate
  });

export const setArrival = (arrival) =>
  ({
    type: C.SET_ARRIVAL,
    payload: arrival
  });

export const setArrivalTimes = (arrival_times) =>
  ({
    type: C.SET_ARRIVAL_TIMES,
    payload: arrival_times
  });

export const setDeparture = (departure) =>
  ({
    type: C.SET_DEPARTURE,
    payload: departure
  });

export const setDeparturePickup = (departure_pickup) =>
  ({
    type: C.SET_DEPARTURE_PICKUP,
    payload: departure_pickup
  });

export const setCompleted = (completed) =>
  ({
    type: C.SET_COMPLETED,
    payload: completed
  });

export const setGuestKind = (guest_kind) =>
  ({
    type: C.SET_GUEST_KIND,
    payload: guest_kind
  });

export const setGuestKindUnknownPlace = (unknown_place) =>
  ({
    type: C.SET_GUEST_KIND_UNKNOWN_PLACE,
    payload: unknown_place
  });

export const setCountryCode = (country_code) =>
  ({
    type: C.SET_COUNTRY_CODE,
    payload: country_code
  });

export const setEnvironment = (environment) =>
  ({
    type: C.SET_ENVIRONMENT,
    payload: environment
  });

export const setGuestType = (guestType) =>
  ({
    type: C.SET_GUEST_TYPE,
    payload: guestType
  });

export const setLocalProfileElements = (local_profile_elements) =>
  ({
    type: C.SET_LOCAL_PROFILE_ELEMENTS,
    payload: local_profile_elements
  });

export const setPickup = (pickup) =>
  ({
    type: C.SET_PICKUP,
    payload: pickup
  });

export const setProducts = (products) =>
  ({
    type: C.SET_PRODUCTS,
    payload: products
  });

export const setProduct = (product) =>
  ({
    type: C.SET_PRODUCT,
    payload: product
  });

export const setReferral = (referral) =>
  ({
    type: C.SET_REFERRAL,
    payload: referral
  });

export const setRegistered = (registered) =>
  ({
    type: C.SET_REGISTERED,
    payload: registered
  });

export const setUser = (user) => ({
  type: C.SET_USER,
  payload: user
})

export const setOnshore = (onshore) => ({
  type: C.SET_ONSHORE,
  payload: onshore
})

export const setVaccinationInfo = (vaccination_info) =>
  ({
    type: C.SET_VACCINATION_INFO,
    payload: vaccination_info
  })

export const setVaccinationOptions = (vaccination_options) =>
  ({
    type: C.SET_VACCINATION_OPTIONS,
    payload: vaccination_options
  })

export const setUploadStatus = status => ({
  type: C.SET_UPLOAD_STATUS,
  payload: { status }
})

export const setUploadProgress = progress => ({
  type: C.SET_UPLOAD_PROGRESS,
  payload: { progress }
})

export const resetUpload = () => ({ type: C.RESET_UPLOAD })
